import Api from './api.service'

export default {
  create (object) {
    return Api().post('productParameter/create', object)
  },
  get (id) {
    return Api().get('productParameter/get/' + id)
  },
  list (filter) {
    return Api().get('productParameter/get', { params: filter })
  },
  update (object) {
    return Api().put('productParameter/edit/' + object.id, object.object)
  }
}